import { createSlice } from "@reduxjs/toolkit";

export const mediosSlices = createSlice({
  name: "medios",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = mediosSlices.actions;

export default mediosSlices.reducer;
